import React, { useEffect, useRef, useMemo } from 'react'

import Inputmask, { Options as InputMaskOptions } from 'inputmask'
import { RegisterOptions } from 'react-hook-form'

type UseInputMaskProps =
  | (Omit<InputMaskOptions, 'mask'> & {
      register?: undefined
      rules?: undefined
    })
  | (Omit<InputMaskOptions, 'mask'> & {
      register: (ref: HTMLInputElement | null, rules?: RegisterOptions) => void
      rules: RegisterOptions
    })

interface UseInputMask {
  (maks: InputMaskOptions['mask'], props?: UseInputMaskProps): React.RefObject<HTMLInputElement>
}

const useInputMask: UseInputMask = (mask, props = {}) => {
  const { register, rules, ...options } = props
  const ref = useRef<HTMLInputElement>(null)

  const maskInput = useMemo(
    () =>
      Inputmask({
        mask,
        ...options,
      }),
    [mask, options],
  )

  useEffect(() => {
    if (!ref.current) {
      return
    }

    maskInput.mask(ref.current)

    if (register) {
      register(ref.current, rules)
    }
  }, [maskInput, register, rules])

  return ref
}

export default useInputMask
